import { FC, useEffect } from 'react';
import {
  Container,
  Box
} from '@mui/material';
import PageGrid from 'components/PageGrid';
import AddIcon from '@mui/icons-material/Add';
import { observer } from "mobx-react"
import store from "./store"
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import PopupGrid from 'components/PopupGrid';
import Organization_settingPopupForm from 'features/Organisation_setting/Organization_settingAddEditView/popupForm'
import styled from 'styled-components';
import CustomButton from 'components/Button';


type organization_settingListViewProps = {
  idMain: number;
};


const Organization_settingListView: FC<organization_settingListViewProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;


  useEffect(() => {
    if (store.idMain !== props.idMain) {
      store.idMain = props.idMain
    }
    store.loadorganization_settings()
    return () => store.clearStore()
  }, [props.idMain])


  const columns: GridColDef[] = [
    {
      field: 'setting_key',
      headerName: translate("label:organization_settingListView.setting_key"),
      flex: 1,
      renderCell: (param) => (<div data-testid="table_organization_setting_column_setting_key"> {param.row.setting_key} </div>),
      renderHeader: (param) => (<div data-testid="table_organization_setting_header_setting_key">{param.colDef.headerName}</div>)
    },
    {
      field: 'setting_value',
      headerName: translate("label:organization_settingListView.setting_value"),
      flex: 1,
      renderCell: (param) => (<div data-testid="table_organization_setting_column_setting_value"> {param.row.setting_value} </div>),
      renderHeader: (param) => (<div data-testid="table_organization_setting_header_setting_value">{param.colDef.headerName}</div>)
    },
    // {
    //   field: 'data_type',
    //   headerName: translate("label:organization_settingListView.data_type"),
    //   flex: 1,
    //   renderCell: (param) => (<div data-testid="table_organization_setting_column_data_type"> {param.row.data_type} </div>),
    //   renderHeader: (param) => (<div data-testid="table_organization_setting_header_data_type">{param.colDef.headerName}</div>)
    // },
    {
      field: 'description',
      headerName: translate("label:organization_settingListView.description"),
      flex: 2,
      renderCell: (param) => (<div data-testid="table_organization_setting_column_description"> {param.row.description} </div>),
      renderHeader: (param) => (<div data-testid="table_organization_setting_header_description">{param.colDef.headerName}</div>)
    },
  ];

  let type1: string = 'popup';
  let component = null;
  switch (type1) {
    case 'form':
      component = <PageGrid
        title={translate("label:organization_settingListView.entityTitle")}
        onDeleteClicked={(id: number) => store.deleteorganization_setting(id)}
        columns={columns}
        data={store.data}
        tableName="organization_setting" />
      break
    case 'popup':
      component = (
        <PopupGrid
          title={translate("label:organization_settingListView.entityTitle")}
          onDeleteClicked={(id: number) => store.deleteorganization_setting(id)}
          onEditClicked={(id: number) => store.onEditClicked(id)}
          columns={columns}
          hideAddButton
          customBottom={
            <Box>
              <CustomButton
                variant='contained'
                sx={{ mb: 1 }}
                id={`organization_settingAddButton`}
                onClick={() => store.onEditClicked(0)}
                endIcon={<AddIcon />}
              >
                {translate('add')}
              </CustomButton>
            </Box>
          }
          data={store.data}
          tableName="organization_setting"
        />
      );
      break
  }


  return (
    <Container maxWidth='xl' sx={{ mt: 4 }}>
      {component}

      <Organization_settingPopupForm
        openPanel={store.openPanel}
        id={store.currentId}
        onBtnCancelClick={() => store.closePanel()}
        onSaveClick={() => {
          store.closePanel()
          store.loadorganization_settings()
        }}
      />

    </Container>
  );
})



export default Organization_settingListView